"use client";

import Script from "next/script";

export default function CookieConsent() {
  return (
    <>
      <Script
        id="tarteaucitron-init"
        src="/tarteaucitron/tarteaucitron.js"
        strategy="lazyOnload"
        onLoad={() => {
          // Delay initialization by 2 seconds to free main thread
          setTimeout(() => {
            // Custom text in French
            window.tarteaucitronCustomText = {
              "alertBigPrivacy": "Ce site utilise des cookies pour améliorer votre expérience. Vous pouvez choisir les services que vous acceptez.",
              "acceptAll": "Tout accepter",
              "denyAll": "Tout refuser",
              "personalize": "Personnaliser",
              "close": "Fermer"
            };

            if (typeof window.tarteaucitron !== "undefined") {
              window.tarteaucitron.init({
                "privacyUrl": "/legal/confidentialite",
                "bodyPosition": "bottom",
                "hashtag": "#tarteaucitron",
                "cookieName": "tarteaucitron",
                "orientation": "bottom",
                "groupServices": false,
                "showDetailsOnClick": true,
                "serviceDefaultState": "wait",
                "showAlertSmall": false,
                "cookieslist": true,
                "showIcon": true,
                "iconPosition": "BottomLeft",
                "adblocker": false,
                "DenyAllCta": true,
                "AcceptAllCta": true,
                "highPrivacy": true,
                "handleBrowserDNTRequest": false,
                "removeCredit": false,
                "moreInfoLink": true,
                "useExternalCss": false,
                "useExternalJs": false,
                "mandatory": true,
                "mandatoryCta": true,
                "closePopup": false,
                "readmoreLink": "/legal/cookies"
              });

              // Register Google Analytics (GA4) — fires only after consent
              window.tarteaucitron.user = window.tarteaucitron.user || {};
              window.tarteaucitron.user.gtagUa = "G-H5DK2QBH0L";
              window.tarteaucitron.user.gtagMore = function () { /* extra gtag calls if needed */ };
              (window.tarteaucitron.job = window.tarteaucitron.job || []).push("gtag");
            }
          }, 2000);
        }}
      />
    </>
  );
}